import * as React from "react";
import { singleton } from "logic/singleton";
const ReplaySearchContext = React.createContext({
  alertId: void 0,
  definitionId: void 0,
  type: void 0
});
export default singleton("contexts.ReplaySearchContext", () => ReplaySearchContext);
